import { render, staticRenderFns } from "./ContentOsteopathie.vue?vue&type=template&id=cd537c3c&"
import script from "./ContentOsteopathie.vue?vue&type=script&lang=js&"
export * from "./ContentOsteopathie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports